import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { nouns } from "@/components/sheet/nouns";
import { PhoneLoop } from "./Phone";
import { HeroStore, StoreTabs, visitorPlatform } from "./StoreTab";

/*
  The first viewport: aSTRING's line at poster scale on bare paper, a vermilion
  strip woven through it (the start of the page's one thread, which Thread.tsx
  draws from here down the page), the three room nouns, the plate and the App Store
  beside it. Directly under it, on the Loop's cobalt sheet, the app itself
  running on a phone, peeking into the bottom of a 390x844 screen: art first,
  then the evidence, and the evidence is the phone, because that is where
  aSTRING is used (owner's decision, 2026-10-10; PRODUCT.md, Platform Reality).

  The hero's tab follows the phone in the visitor's hand: the App Store on an
  iPhone, Google Play on Android, where the App Store is a door she cannot
  open, and both as one cut slip on a computer. The stage below offers both
  stores, hers first.
*/
export function Hero() {
  const { t } = useTranslation();
  const platform = visitorPlatform();

  return (
    <>
      <section className="sh-hero" aria-labelledby="sh-hero-title">
        <h1 id="sh-hero-title" className="sh-hero__title">
          {t("hero.headline1")} {t("hero.headline2")}
        </h1>
        <div className="sh-hero__foot">
          <p className="sh-hero__lead">{nouns(t("hero.lead"))}</p>
          <div className="sh-hero__actions" data-cta>
            <Link to="/signup" className="sh-plate">
              {t("hero.cta")}
            </Link>
            <HeroStore platform={platform} />
          </div>
        </div>
      </section>

      <section id="app" className="sh-stage" aria-labelledby="sh-app-title">
        <div className="sh-stage__sheet sh-app">
          <div className="sh-app__device">
            <PhoneLoop />
          </div>
          <div className="sh-app__copy">
            <h2 id="sh-app-title" className="sh-h2 sh-app__title">
              {t("landing.app.title")}
            </h2>
            <p className="sh-body">{nouns(t("landing.app.body"))}</p>
            <div className="sh-app__stores">
              <StoreTabs platform={platform} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
